var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.055,14.242v2.039H23.719v9.477h-7.266v-9.477H6.07v-2.039H34.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.488,14.242h7.5L54.21,25.758h-6.819L35.707,14.242h7.711l7.5,8.742L58.488,14.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.07,28.969h8.521L40.555,46.963v10.795h-7.52V46.963L20.584,28.969h8.862l7.471,12.539L44.07,28.969z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvY);
export default __webpack_public_path__ + "static/media/TV-Y.cc68a53eba578dd45a340b6d93874686.svg";
export { ForwardRef as ReactComponent };